export default __webpack_public_path__ + "static/media/4.10aa9c9f.mp4";